import { getApiBaseUrl } from '../../utils/apiBaseUrl';

export const ValidateOtpAsync = async (
  email: string,
  fullName?: string,
  phoneNumber?: string,
  mailOtp?: string,
  referalId?: number
): Promise<any | null> => {
  const payload = {
    email,
    userName: fullName || null,
    phoneNumber: phoneNumber || null,
    mailOtp: mailOtp || '',
    referalId: referalId || null
  };

  if (!navigator.onLine) {
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Account/ValidateOtpAsync`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      console.error("Failed to validate OTP");
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("Error during OTP validation:", error);
    return null;
  }
};
